import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { IShopAccess } from '../api/model/login-access-token';

@customElement('shop-access')
export class ShopAccess extends LitElement {
  @property({ type: Object }) shop!: IShopAccess;

  static styles = css`
    ul {
      list-style-type: none;
      padding: 0;
    }
  `;

  render() {
    return html`
      <li>
        ${this.shop.shopDisplayName}
        <ul>
          ${this.shop.roles.map((role) => html`<li>${role}</li>`)}
        </ul>
      </li>
    `;
  }
}
